export const painPoints: string[] = [
  'Hours spent searching for drills, progressions and session ideas',
  'Repeating the same throws and exercises because they are easiest to remember',
  'Sessions that feel disconnected from one week to the next',
  'Mixed-level groups that are harder to organize',
  'Athletes progressing without a clear technical pathway',
  'More time planning and less time actually coaching',
  'Entering the dojo with ideas instead of a complete structure',
]
